<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import staticLookups from '@/js/staticLookups.js'
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tweezer from 'tweezer.js'
import { easeOutQuad } from 'ez.js'

const store = useStore();

const scrollContainer = ref(null)
const scrollAmountY = ref(0)

// Method 1: Track via inline scroll event handler
const handleScroll = (event) => {
  const { scrollTop, scrollLeft } = event.target
  scrollAmountY.value = scrollTop
  console.log(scrollTop)
}

const isMounted = ref(false);

const isLoaded = ref(false);
const loadedTimeout = ref(null);
const animateIn = ref(false);

const currentStandings = computed(() => {
    if(animateIn.value){
        return store.getters.staticResultsLookup;
    } else {
        return []
    }
})

onMounted(() => {
    isMounted.value = true;
    isLoaded.value = false;
    animateIn.value = false;

    loadedTimeout.value = setTimeout(() => {
        loadedTimeout.value = null;
        isLoaded.value = true;

        loadedTimeout.value = setTimeout(() => {
            animateIn.value = true;
        }, 500)
    }, 1500)

    window.addEventListener("left-scroll", (event) => {
        console.log(isMounted.value)
        if(isMounted.value) store.commit("isModuleOpen", false);
    });
})

onUnmounted(() => {
    isMounted.value = false;
    if(loadedTimeout.value != null){
        clearTimeout(loadedTimeout.value)
    }
})


function onBeforeEnter(el) {
    if (el.dataset.index < 6) {
        el.style.opacity = 0;
        el.style.transform = `translateX(-20px)`
      } else {
        el.style.opacity = 1;
        el.style.transform = `translateX(0px)`
      }
}

async function onEnter(el, done) {
    if (el.dataset.index < 6) {
        await new Promise(resolve => setTimeout(resolve, el.dataset.index * 100))
        new Tweezer({
            start: 0,
            end: 1,
            duration: 600,
            easing: easeOutQuad
        })
        .on('tick', value => {
            el.style.opacity = value
            el.style.transform = `translateX(${(1-value)*-20}px)`
        })
        .on('done', done)
        .begin() // this fires the tweening
      } else {
        done();
      }
}

</script>

<template>
    <div class = "season-standings">
        <div class = "overlay-border"></div>
        <div class = "modal-content flex-descending-column " @scroll="handleScroll" >
            <div class = "modal-header">
                <img src = "../../public/assets/imgs/seasonheader.png">

                <div class = "header-right">
                    <span class = "header-text" >Season Standings (Live)</span>
                    <span class = "header-sub" >2026</span>
                </div>
            </div>
            <transition name = "fade" mode = "out-in">

            
                <div class="loading-area" v-if="!isLoaded" key = "loader">
                    <LoadingSpinner></LoadingSpinner>
                </div>
                <div v-else key = "standings">
                    <TransitionGroup tag="ul" :css="false" @before-enter="onBeforeEnter" @enter="onEnter">
                        <button v-for="(standingItem, index) in currentStandings" :data-index="index"
                            :key="standingItem.position" class="standing-item focusable">
                            <div class="left-section">
                                <div class="list-number">{{ standingItem.position }}.</div>
                                <img class="car-logo"
                                    :src="`https://cf.nascar.com/data/images/carbadges/1/${standingItem.car_no}.png`">
                                <div class="driver-name">{{ standingItem.driver_last_name }}</div>
                            </div>

                            <div class="right-section">
                                <img class="brand-logo"
                                    v-if="standingItem.manufacturer != null && staticLookups.manufacturerBadges[standingItem.manufacturer] != null"
                                    :style="{
                                        width: staticLookups.manufacturerBadges[standingItem.manufacturer].width,
                                        height: staticLookups.manufacturerBadges[standingItem.manufacturer].height
                                    }"
                                    :src="staticLookups.manufacturerBadges[standingItem.manufacturer].src">
                            </div>

                            <div class="right-section">
                                <div class="points">
                                    {{ standingItem.points }}
                                </div>
                            </div>
                        </button>
                    </TransitionGroup>
                </div>
           </transition>
            
        </div>
        
        <div class = "scroll-bar-offset">

        </div>
    </div>
  
</template>

<style lang="scss" scoped>

@import '../sass/GlobalClasses';
@import '../sass/Settings';

.modal-header{
    width: 97%;
}

.season-standings{
    padding: vw(20);
    overflow: hidden;
    position: fixed;
    left: vw(40);
    top: vw(40);
    right: vw(40);
    bottom: vw(40);
}

.header-text{
    width: 100% !important;
}

.standing-item:nth-child(odd) {
  background-color: #A2A2A2;
}

.standing-item:nth-child(even) {
  background-color: #313131;
}

.standing-item{
    position: relative;
    width: vw(472);
    min-height: vw(64);
    height: vw(64);
    font-size: vw(23);
    color: white;
    border-radius: vw(5);
    margin-bottom: vw(10);
    border: none;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: vw(30);

    &:before {
        position: absolute;
        inset: vw(-1);
        z-index: 1; 
        border-radius: vw(5);
        border: solid vw(1) #0000;
        background: linear-gradient(10deg, #FFFFFF, #4c4c4c) border-box;
        --lyr: conic-gradient(red 0 0); /* any kind of gradient that's opaque everywhere */
        /* exclude padding-box (that is, mask out everything but the border area) */
        mask: var(--lyr) padding-box exclude, var(--lyr);
        content: ''
    }


    .left-section{
        position: relative;
        height: 100%;
        width: contain;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-family: 'GoogleSansFlex';
        font-weight: 300;

        .list-number{
            position: relative;
        }

        .car-logo{
            position: relative;
            width: auto;
            height: vw(40);
            margin-left: vw(15);
        }

        .driver-name{
            position: relative;
            margin-left: vw(10);
        }
    }

    .right-section{
        position: absolute;
        height: 100%;
        width: contain;
        right: 0;
        top: 0;

        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .points{
            position: relative;
            width: auto;
            margin-right: vw(25);
            font-weight: 400;
        }


        .brand-logo{
            position: relative;
            width: auto;
            height: vw(50);
            margin-right: vw(115);

            transform: translateX(50%);
        }
    }

    
    
}

.loading-area {
    margin-top: vw(105);

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .sponsored-by {
        position: relative;
        width: vw(76);
        height: auto;
        margin-top: vw(20);
    }

    .sponsored-image {
        position: relative;
        width: vw(116);
        height: auto;
        margin-top: vw(8);
    }
}

.standing-item:focus{
    &:before{
        border-radius: vw(7);
        inset: vw(-1);
        border: solid vw(3) #0000;
        background: white border-box;
    }
}

</style>
